// extracted by mini-css-extract-plugin
export default {"day":"h3qyDyn0sqLQhGcfL0e8"};